import { IcTitleComponent } from '@shared/components/ui-kit/ic-title/ic-title.component';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-offline',
  imports: [IcTitleComponent, ],
  templateUrl: './offline.component.html',
  styleUrl: './offline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfflineComponent {


}
